import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getFacetsCountFromAlgoliaOnMasterAuthStatus,
  GetFacetsCountFromAlgoliaOnMasterAuthStatusParams,
} from "../../../../shared/api/postCall/getFacetsCountFromAlgoliaOnMasterAuthStatus";
import { AlgoliaFacetCountsResponseModel } from "../../../data-model/algoliaFacetCountsResponseModel";

interface AlgoliaFacetsCountState {
  data?: AlgoliaFacetCountsResponseModel;
  loading?: boolean;
  error?: string;
}

const initialState: AlgoliaFacetsCountState = {
  data: undefined,
  loading: false,
  error: undefined,
};

export const algoliaFacetsCountSlice = createSlice({
  name: "algoliaFacetsCount",
  initialState,
  reducers: {
    setAlgoliaFacetsCount: (
      state,
      action: PayloadAction<AlgoliaFacetCountsResponseModel>,
    ) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      state.data = undefined;
      state.error = undefined;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.data = undefined;
    },
    resetAlgoliaFacetsCount: (state) => {
      state.data = undefined;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const {
  setAlgoliaFacetsCount,
  setLoading,
  setError,
  resetAlgoliaFacetsCount,
} = algoliaFacetsCountSlice.actions;

export const fetchCountsByMasterAuthStatusByAlgolia =
  (payload: GetFacetsCountFromAlgoliaOnMasterAuthStatusParams) =>
  async (dispatch, getState: any) => {
    const { algoliaFacetsCount } = getState();
    if (algoliaFacetsCount.loading) {
      return;
    }
    dispatch(setLoading(true));
    try {
      const response =
        await getFacetsCountFromAlgoliaOnMasterAuthStatus(payload);
      dispatch(
        setAlgoliaFacetsCount(response as AlgoliaFacetCountsResponseModel),
      );
    } catch (error) {
      dispatch(setError(error as string));
    }
  };

export default algoliaFacetsCountSlice.reducer;
